module.exports = __webpack_public_path__ + "static/img/tea_m_cont.8bd2fdef.jpg";